import type { RingFinish } from '@jouzen/ecom-components/v3/types/ringFinish';
import type { MessageKey } from 'types/LocaleMessageKey';

const getRingPdpSeoMetadata = ({
  defaultDescription = 'pdp_seo_description_horizon',
  metadataByFinish,
  selectedFinish,
}: {
  defaultDescription?: MessageKey;
  metadataByFinish: Partial<
    Record<RingFinish, { title: MessageKey; description?: MessageKey }>
  >;
  selectedFinish?: RingFinish | '';
}): {
  description: MessageKey;
  title: MessageKey;
} => {
  const finishes = Object.keys(metadataByFinish) as RingFinish[];

  // Verify that titlesByFinish contains at least one entry
  if (!finishes[0]) {
    throw new Error('No SEO titles provided for any finish');
  }

  // Validate finish and use first finish in dictionary as fallback
  const validFinish: keyof typeof metadataByFinish =
    selectedFinish && selectedFinish in metadataByFinish
      ? selectedFinish
      : finishes[0];

  return {
    ...metadataByFinish[validFinish]!,
    description:
      metadataByFinish[validFinish]?.description ?? defaultDescription,
  };
};

export default getRingPdpSeoMetadata;
